import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CmsService } from '../../cms.service';
import * as PrismicDOM from 'prismic-dom';import { Component, OnInit } from '@angular/core';
import { ConnectService } from '../../connect.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {
  public product;
  public id;
  public cat;
  public activeIndex = 0;

  public connect = () => this.connectService.toggleConnect(true);


  public generateMarkup(data) {
    return PrismicDOM.RichText.asHtml(data);
  }
  constructor(private route: ActivatedRoute, private cms: CmsService, public connectService:ConnectService, private titleService: Title) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.cat = this.route.snapshot.paramMap.get('cat');

    this.cms.getProduct(this.id).subscribe((response) => {
      this.product = response;
      // console.log("Content: ", response);
      let name;
      if (this.product && this.product.data && this.product.data.name) {
        name = this.product.data.name;
      }
      this.titleService.setTitle(name ? `${name} -- ThinSlabz® by Rosetta Stone Group` : 'ThinSlabz®');

      // if (response.results && response.results.length > 0) {
      //   this.featuredPost = response.results[0];
      // }
    });
    // .catch(console.error);
  }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/products/product/product.component.ts